import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import TrackingInfoItem from './TrackingInfoItem.component';
import UI from '../../ui';
import { InboundStatus } from '../Status';

const { WrappedButton, WrappedButtonType } = UI;

const TrackingInfo = ({
	carrierOptions,
	showMobileView,
	isMobile,
	editingInbound,
	saveInbound,
	updateInstructions,
	validations,
	updateValidation,
}) => {
	const [trackingInfoList, setTrackingInfoList] = useState([]);

	useEffect(() => {
		const updatedValidations = validations;

		// Anything in here is fired on component mount.
		if (isEmpty(editingInbound.trackingInfo)) {
			setTrackingInfoList([
				{
					carrier: '',
					trackingNumber: '',
					trackingId: 'tracking1',
					wasCarrierSet: false,
				},
			]);

			updatedValidations.tracking = {
				0: 1,
			};
			updateValidation(updatedValidations);
		} else {
			setTrackingInfoList([...editingInbound.trackingInfo]);
		}
	}, [editingInbound]);

	const onTrackingInfoItemChange = (index, name, value) => {
		const newTrackingInfoList = [...trackingInfoList];
		const trackingItem = newTrackingInfoList[index];

		trackingItem[name] = value;

		saveInbound({ trackingInfo: newTrackingInfoList });
	};

	const addTrackingInfoItem = () => {
		const newTrackingInfoList = [...trackingInfoList];
		const updatedValidations = validations;

		updatedValidations.tracking[newTrackingInfoList.length] = 1;

		newTrackingInfoList.push({
			carrier: '',
			trackingNumber: '',
			trackingId: 'trackingId',
			wasCarrierSet: false,
		});
		saveInbound({ trackingInfo: newTrackingInfoList });
		updateValidation(updatedValidations);
	};

	const onDeleteButtonClick = index => {
		const updatedValidations = validations;

		// Shifts validations for products
		for (let x = index; x < trackingInfoList.length - 1; x++) {
			updatedValidations.tracking[x] = updatedValidations.tracking[x + 1];
		}

		trackingInfoList.splice(index, 1);
		saveInbound({ trackingInfo: trackingInfoList });

		delete updatedValidations.tracking[trackingInfoList.length];
		updateValidation(updatedValidations);
	};

	const updateShippingInstructions = (header, instructions) => {
		updateInstructions('shipping', header, instructions);
	};

	const mobileClassName = showMobileView ? 'mobile-wrapper' : '';

	return (
		<div className={`common-inbound-details-tracking-info ${mobileClassName}`}>
			{showMobileView && <div className="tracking-info-header">Tracking Numbers</div>}

			<div className="tracking-info-content">
				<div className="p-grid p-col-12 p-dir-col tracking-list">
					{!showMobileView && (
						<div className="sub-header p-grid p-col-12 p-dir-row">
							<p className="p-lg-9">Tracking Number</p>
							<p className="p-lg-3">Carrier</p>
						</div>
					)}

					{trackingInfoList.length > 0 &&
						trackingInfoList.map((trackingInfoItem, index) => (
							<TrackingInfoItem
								key={`${trackingInfoItem.trackingId}_index${index}`}
								carrierOptions={carrierOptions}
								showMobileView={showMobileView}
								isMobile={isMobile}
								onActionTrigger={onTrackingInfoItemChange}
								trackingIndex={index}
								trackingInfoItem={trackingInfoItem}
								inboundStatus={editingInbound.status}
								onDeleteButtonClick={onDeleteButtonClick}
								updateShippingInstructions={updateShippingInstructions}
								validations={validations}
								updateValidation={updateValidation}
							/>
						))}
				</div>

				{editingInbound.status !== InboundStatus.Completed &&
					editingInbound.status !== InboundStatus.Cancelled && (
						<WrappedButton
							buttonType={WrappedButtonType.Icon}
							label="Add another Tracking Number"
							icon="add-icon"
							className="add-tracking"
							onClick={addTrackingInfoItem}
							dataqa="tracking-info-item-add"
						/>
					)}
			</div>
		</div>
	);
};

export default TrackingInfo;
